define('mapboxGL',['app'],function(app){
    var mapboxGL,turf;
    function initAccessToken(){
        mapboxGL.accessToken = app.c('_MAPBOX_ACCESS_TOKEN_');
    }
    function requireMapboxGL(callback,err){
        require(['mapboxGLJS','turf'],function(mbgl,t){
            mapboxGL = mbgl;
            turf = t;
            initAccessToken();
            callback(mapboxGL,turf);
        },err)
    }
    //app.once('hooksStarted',initAccessToken);
    return {
        init:function(callback,err){
            if(mapboxGL){
                initAccessToken();
                callback(mapboxGL,turf);
            }else{
                requireMapboxGL(callback,err);
            }
        }
    };
});
